import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "flex justify-between items-center col-span-12" }
const _hoisted_2 = { class: "text-xl md:text-2xl font-bold" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = {
  key: 0,
  class: "flex flex-col my-4 col-span-6"
}
const _hoisted_5 = {
  class: /*#__PURE__*/_normalizeClass(`mb-2`)
}
const _hoisted_6 = {
  key: 1,
  class: "flex flex-col my-4 col-span-6"
}
const _hoisted_7 = {
  class: /*#__PURE__*/_normalizeClass(`mb-2`)
}
const _hoisted_8 = { class: "my-4 col-span-12" }
const _hoisted_9 = { class: "mb-2" }
const _hoisted_10 = { class: "my-4 col-span-12" }
const _hoisted_11 = { class: "mb-2" }
const _hoisted_12 = { class: "flex justify-end" }
const _hoisted_13 = { class: "text-xs" }
const _hoisted_14 = {
  key: 2,
  class: "my-4 col-span-12"
}
const _hoisted_15 = { class: "mb-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Textarea = _resolveComponent("Textarea")!
  const _component_Dropzone = _resolveComponent("Dropzone")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_Loader, {
      loader: _ctx.formLoader,
      label: "Carregando...",
      loaderType: "progress",
      loaderSize: "h-96"
    }, null, 8, ["loader"]),
    (!_ctx.formLoader)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (_ctx.submitMaterial()), ["prevent"])),
          class: "grid grid-cols-12 items-center gap-x-3"
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$route.params.id ? _ctx.$t("objects.edit") : _ctx.$t("objects.add")), 1),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_Button, {
                label: _ctx.$t('labels.cancel'),
                class: "btn-outline p-button-sm",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmModal()))
              }, null, 8, ["label"]),
              _createVNode(_component_Button, {
                label: _ctx.$t('labels.save'),
                class: "btn-primary p-button-sm",
                type: "submit"
              }, null, 8, ["label"])
            ])
          ]),
          (_ctx.isAdaptative)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("objects.inputs.classification")), 1),
                _createVNode(_component_Dropdown, {
                  id: "learning-input",
                  modelValue: _ctx.form.material.learningGroupType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.material.learningGroupType) = $event)),
                  options: _ctx.learningTypes,
                  optionLabel: "name",
                  optionValue: "code",
                  placeholder: _ctx.$t('objects.inputs.select'),
                  class: _normalizeClass(_ctx.v$.form.material.learningGroupType.$error ? 'p-invalid' : '')
                }, null, 8, ["modelValue", "options", "placeholder", "class"]),
                _createVNode(_component_Errors, {
                  errors: _ctx.v$.form.material.learningGroupType.$errors
                }, null, 8, ["errors"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isAdaptative)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("objects.inputs.time")), 1),
                _createVNode(_component_InputMask, {
                  id: "duration-input",
                  mask: "99:99:99",
                  modelValue: _ctx.form.material.expectedConclusionTime,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.material.expectedConclusionTime) = $event)),
                  placeholder: "00:00:00",
                  class: _normalizeClass(_ctx.v$.form.material.expectedConclusionTime ? 'p-invalid' : '')
                }, null, 8, ["modelValue", "class"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("objects.inputs.name")), 1),
            _createVNode(_component_InputText, {
              id: "title-input",
              type: "text",
              name: "name",
              modelValue: _ctx.form.material.name,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.material.name) = $event)),
              class: _normalizeClass(_ctx.v$.form.material.name.$error ? 'p-invalid' : ''),
              maxlength: 50
            }, null, 8, ["modelValue", "class"]),
            _createVNode(_component_Errors, {
              errors: _ctx.v$.form.material.name.$errors,
              actualLength: _ctx.form.material.name?.length,
              maxLength: 50
            }, null, 8, ["errors", "actualLength"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.$t("objectives.inputs.description")) + " " + _toDisplayString(_ctx.$t("labels.generic", { pt: "Opcional", en: "Optional" })), 1),
            _createVNode(_component_Textarea, {
              id: "description-input",
              autoResize: true,
              rows: "10",
              cols: "30",
              modelValue: _ctx.form.material.description,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.material.description) = $event)),
              maxlength: 999
            }, null, 8, ["modelValue"]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.form.material.description?.length) + "/999", 1)
            ])
          ]),
          (_ctx.$route.params.type == 'add')
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("labels.generic", {
              pt: "Fazer upload de novo conteúdo",
              en: "Upload new content",
            })), 1),
                _createVNode(_component_Dropzone, {
                  files: _ctx.form.files,
                  errors: _ctx.v$.form.files.$errors,
                  btnLabel: _ctx.$t('labels.select')
                }, null, 8, ["files", "errors", "btnLabel"])
              ]))
            : _createCommentVNode("", true)
        ], 32))
      : _createCommentVNode("", true),
    _createVNode(_component_ConfirmDialog)
  ]))
}